import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <button
      className="language-switcher"
      onClick={toggleLanguage}
      aria-label={t('language')}
      title={t('language')}
    >
      <span className="language-icon">🌐</span>
      <span className="language-text">
        {language === 'en' ? 'EN' : 'ES'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;

